module.exports = __webpack_public_path__ + "img/socialSecurity.046b7983.png";